import React from 'react';

const PortfolioStockFormModal = React.lazy(() => import('../components/FormModal'));
const portfolioStockModalRegistry = {
    personalize_portfolioStockId: PortfolioStockFormModal
};
export default portfolioStockModalRegistry;
